import React from 'react'
import PropTypes from 'prop-types'

const SortIcon = ({ active, direction }) => {
  if (!active) {
    return (
      <span className="tw:ml-1 tw:inline-block">
        <i className="fas fa-long-arrow-alt-up" />
        <i className="fas fa-long-arrow-alt-down" />
      </span>
    )
  }

  const iconClass = direction === 'asc' ? 'fa-long-arrow-alt-up' : 'fa-long-arrow-alt-down'

  return <i className={`fas ${iconClass} tw:ml-1`} />
}

SortIcon.propTypes = {
  active: PropTypes.bool,
  direction: PropTypes.oneOf(['asc', 'desc'])
}

SortIcon.defaultProps = {
  active: false,
  direction: 'desc'
}

export default SortIcon
